<template>
  <vs-popup
    id="newRawMaterialPopup"
    :active.sync="isSidebarActiveLocal"
    v-esc="escape"
    :title="
      Object.entries(this.data).length === 0
        ? 'Yeni Hammadde'
        : 'Hammadde Düzenle'
    "
  >
    <variant-price-modal
      :is-active="variantPriceIsActive"
      @saveVariant="saveVariantOptions"
      @close="closeVariantBuyPrice"
      :variant="toSetBuyPriceVariant"
      :alternate-units="newRawMaterial.alternateUnits"
    />
    <form data-vv-scope="form-1" @keyup.enter="submitData">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12">
          <span class="text-primary text-smaller weight-600"> Stok Kodu </span>
          <vs-input
            id="code"
            name="Stok Kodu"
            v-validate="{
              required: true,
              checkStockCode: newRawMaterial.id != null ? newRawMaterial.id : 0,
            }"
            v-model="newRawMaterial.stockCode"
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            placeholder="Stok Kodu"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('form-1.Stok Kodu')"
            >{{ errors.first("form-1.Stok Kodu") }}</span
          >
        </vs-row>

        <vs-row vs-type="flex" vs-w="12">
          <span class="text-primary text-smaller weight-600"> İsim </span>
          <vs-input
            id="name"
            name="İsim"
            v-validate="'required|min:2|max:60'"
            v-model="newRawMaterial.name"
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            placeholder="İsim"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('form-1.İsim')"
            >{{ errors.first("form-1.İsim") }}</span
          >
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <span class="text-primary text-smaller weight-600">
            Hammadde Kategori
          </span>
          <v-select
            id="rawMaterialCategory"
            v-model="newRawMaterial.rawMaterialCategoryId"
            :reduce="(category) => category.id"
            itemid="id"
            label="name"
            placeholder="Kategori Seçimi"
            :options="rawMaterialCategories"
            class="w-full"
            :clearable="true"
          />
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <span class="text-primary text-smaller weight-600"> Tedarikçi </span>
          <v-select
            :disabled="suppliers.length == 0"
            id="supplier"
            name="Tedarikçi"
            v-validate="'required'"
            @input="resetBuyPrice()"
            v-model="newRawMaterial.supplier"
            itemid="id"
            label="name"
            placeholder="Tedarikçi Seçimi.."
            :options="suppliers"
            class="w-full"
            :clearable="false"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('form-1.Tedarikçi')"
            >{{ errors.first("form-1.Tedarikçi") }}</span
          >
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <span class="text-primary text-smaller weight-600"> Diğer Tedarikçiler </span>
          <v-select
            v-model="newRawMaterial.additionalSuppliers"
            itemid="id"
            label="name"
            placeholder="Diğer Tedarikçi Seçimi.."
            :options="suppliers"
            class="w-full"
            :clearable="true"
            multiple
          >
          </v-select>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="my-2">
          <span class="text-primary text-smaller weight-600">
            Min/Max Limitli
          </span>
          <div class="w-full">
            <vs-switch v-model="newRawMaterial.hasLimits">
              <span slot="on"></span>
              <span slot="off"></span>
            </vs-switch>
          </div>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="my-2">
          <span class="text-primary text-smaller weight-600">
            Sipariş Edilebilir ?
          </span>
          <div class="w-full">
            <vs-switch v-model="newRawMaterial.isOrderable">
              <span slot="on"></span>
              <span slot="off"></span>
            </vs-switch>
          </div>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <span class="text-primary text-smaller weight-600"> KDV(%) </span>
          <vs-input
            id="kdv"
            name="KDV"
            v-validate="'numeric'"
            v-model="newRawMaterial.kdv"
            class="w-full"
            placeholder="KDV(%)"
          />
          <span class="text-danger text-sm" v-show="errors.has('KDV')">{{
            errors.first("KDV")
          }}</span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <span class="text-primary text-smaller weight-600"> Birim </span>
          <v-select
            :disabled="units.length == 0"
            id="unit"
            name="Birim"
            v-validate="'required'"
            @input="getAlternateUnits(newRawMaterial.unit.id)"
            v-model="newRawMaterial.unit"
            itemid="id"
            label="name"
            placeholder="Birim Seçimi.."
            :options="units"
            class="w-full"
            :clearable="false"
          ></v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('form-1.Birim')"
            >{{ errors.first("form-1.Birim") }}</span
          >
        </vs-row>
        <vs-row
          vs-type="flex"
          vs-w="12"
          vs-justify="center"
          vs-align="center"
        >
          <vs-col vs-type="flex" vs-w="6" class="pr-1">
            <vs-row vs-type="flex" vs-w="12">
              <span class="text-primary text-smaller weight-600 w-full">
                Minimum Sipariş Miktarı
              </span>
              <vs-input
                id="minimumOrder"
                name="Min.Sipariş"
                class="w-full"
                v-validate="{
                  required: true,
                  regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                }"
                v-model="newRawMaterial.minimumOrder"
                placeholder="Minimum Sipariş Miktarı"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('form-1.Min.Sipariş')"
                >{{ errors.first("form-1.Min.Sipariş") }}</span
              >
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="pl-1">
            <vs-row vs-type="flex" vs-w="12">
              <span class="text-primary text-smaller weight-600 w-full">
                Sipariş Birimi
              </span>
              <v-select
                id="orderUnit"
                :disabled="
                  newRawMaterial.alternateUnits.length == 0 ||
                  newRawMaterial.unit == null
                "
                name="Sipariş Birimi"
                v-validate="'required'"
                class="w-full"
                v-model="newRawMaterial.orderUnit"
                itemid="id"
                label="name"
                placeholder="Sipariş Birimi Seçimi.."
                :options="newRawMaterial.alternateUnits"
                :clearable="false"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('form-1.Sipariş Birimi')"
                >{{ errors.first("form-1.Sipariş Birimi") }}</span
              >
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-table :data="activeVariants" class="mt-4 w-full">
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          ></div>
          <template slot="thead">
            <vs-th class="w-2/12"> Standart</vs-th>
            <vs-th class="w-3/12"> Kodu</vs-th>
            <vs-th class="w-5/12"> İsim</vs-th>
            <vs-th class="w-2/12"> İşlem</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr
                :data="item"
                :key="indextr"
                v-for="(item, indextr) in data"
              >
                <vs-td class="w-2/12">
                  <vs-switch
                    v-model="item.isDefault"
                    @click="setDefaultVariant(indextr, item)"
                  >
                    <span slot="on"></span>
                    <span slot="off">Standart</span>
                  </vs-switch>
                </vs-td>

                <vs-td class="w-3/12">
                  <vs-input
                    id="code"
                    :name="indextr + 1 + '.Stok Kodu'"
                    v-validate="{
                      required: true,
                      checkStockCode: item.id != null ? item.id : 0,
                    }"
                    v-model="item.stockCode"
                    class="w-full"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="
                      errors.has('form-1.' + (indextr + 1) + '.Stok Kodu')
                    "
                    >{{
                      errors.first("form-1." + (indextr + 1) + ".Stok Kodu")
                    }}</span
                  >
                </vs-td>

                <vs-td class="w-5/12">
                  <vs-input
                    id="name"
                    :name="indextr + 1 + '.İsim'"
                    v-validate="'required|min:2|max:60'"
                    v-model="item.name"
                    class="w-full"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('form-1.' + (indextr + 1) + '.İsim')"
                    >{{
                      errors.first("form-1." + (indextr + 1) + ".İsim")
                    }}</span
                  >
                </vs-td>

                <vs-td class="w-2/12">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-col
                      vs-type="flex"
                      vs-w="6"
                      style="justify-content: center"
                    >
                      <vx-tooltip
                        color="primary"
                        position="top"
                        title="Varyant Fiyat Ayarları"
                      >
                        <template v-slot:content>
                          <div class="w-full d-block">
                            <div class="w-full d-flex justify-center">
                              <span
                                class="weight-500 text-smaller underline text-light"
                              >
                                Alış Fiyatı :
                              </span>
                              <span
                                class="weight-600 text-smaller text-light ml-2"
                              >
                                {{ $toCurrency(item.buyPrice ? item.buyPrice : 0) }}
                              </span>
                            </div>
                            <div v-if="item.buyPriceUnit" class="w-full d-flex">
                              <span
                                class="weight-500 text-smaller underline text-light"
                              >
                                Alış Fiyatı Birimi :
                              </span>
                              <span
                                class="weight-600 text-smaller text-light ml-2"
                              >
                                {{ item.buyPriceUnit ? item.buyPriceUnit.name : 'Belirsiz' }}
                              </span>
                            </div>
                            <div v-if="item.orderUnit" class="w-full d-flex">
                              <span
                                class="weight-500 text-smaller underline text-light"
                              >
                                Sipariş Birimi :
                              </span>
                              <span
                                class="weight-600 text-smaller text-light ml-2"
                              >
                                {{ item.orderUnit ? item.orderUnit.name : 'Belirsiz' }}
                              </span>
                            </div>
                          </div>
                        </template>
                        <vs-button
                          type="gradient"
                          color="primary"
                          class="text-light"
                          icon-pack="feather"
                          icon="icon-settings"
                          @click="setVariantBuyPrice(item)"
                        >
                        </vs-button>
                      </vx-tooltip>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-w="6"
                      style="justify-content: center"
                    >
                      <vs-button
                        v-if="!item.isDefault"
                        type="gradient"
                        color="danger"
                        icon-pack="feather"
                        icon="icon-trash"
                        @click.stop="deleteVariants(item, indextr)"
                      >
                      </vs-button>
                    </vs-col>
                  </vs-row>
                </vs-td>
              </vs-tr>
            </tbody>
            <vs-button
              class="m-4"
              type="gradient"
              icon-pack="feather"
              icon="icon-plus"
              color="primary"
              @click="addNewVariants"
            >
            </vs-button>
          </template>
        </vs-table>
        <vs-row
          v-show="!defaultVariant && hasAnyVariants()"
          vs-type="flex"
          vs-w="12"
        >
          <span class="text-danger text-sm">{{
            "Default Seçimi Yapmayı Unutmayınız."
          }}</span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" v-if="!hasAnyVariants()">
          <vs-col vs-type="block" vs-w="6" class="pr-2">
            <span class="text-primary text-smaller weight-600 w-full">
              Alış Fiyatı
            </span>
            <vs-input
              id="buyPrice"
              name="Alış Fiyatı"
              v-model="newRawMaterial.buyPrice"
              class="w-full"
              v-validate="{
                required: true,
                regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
              }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('form-1.Alış Fiyatı')"
              >{{ errors.first("form-1.Alış Fiyatı") }}</span
            >
          </vs-col>
          <vs-col
            v-if="newRawMaterial.unit"
            vs-type="block"
            vs-w="6"
            class="pl-2"
          >
            <vx-tooltip
              color="primary"
              title="Alış Fiyatı Birimi"
              :text="
                'Alış Fiyatı, bu birim üzerinden hammadde birimine(' +
                newRawMaterial.unit.name +
                ' x' +
                newRawMaterial.buyPriceUnit.originUnitQuantity +
                ') çevirilerek hesaplanacaktır.'
              "
              position="top"
            >
              <span
                class="text-primary underline text-smaller weight-600 w-full"
              >
                Alış Fiyatı Birimi
              </span>
            </vx-tooltip>
            <v-select
              id="buyPriceUnit"
              :disabled="
                newRawMaterial.alternateUnits.length == 0 ||
                newRawMaterial.unit == null
              "
              @input="setConvertedBuyPrice"
              name="Alış Fiyatı Birimi"
              v-validate="'required'"
              class="w-full"
              v-model="newRawMaterial.buyPriceUnit"
              itemid="id"
              label="name"
              placeholder="Alış Fiyatı Birimi Seçimi.."
              :options="newRawMaterial.alternateUnits"
              :clearable="false"
            >
            </v-select>
          </vs-col>
        </vs-row>
        <vs-textarea
          id="description"
          name="Açıklama"
          v-model="newRawMaterial.description"
          class="w-full mt-5"
          label="Açıklama"
        />
      </vs-row>
    </form>
    <div class="flex mt-5 px-6 pb-4">
      <vs-button
        class="mr-auto"
        type="gradient"
        color="danger"
        @click="isSidebarActiveLocal = false"
      >
        Vazgeç
      </vs-button>
      <vs-button class="ml-auto" color="success" @click="submitData"
        >Kaydet
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VariantsStateTypes from "../../../model/constants/VariantsStateTypes";
import {
  createNewRawMaterial,
  updateRawMaterial,
  checkNewStockCode,
  getConvertedBuyPrice,
} from "@/api/RawMaterial";
import { getSupplierNameList } from "@/api/Supplier";
import { getRawMaterialCategoryNameList } from "@/api/RawMaterialCategory";
import { getUnitNameList, getFullAlternateList } from "@/api/Unit";
import VariantPriceModal from "./VariantPriceModal";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      units: [],
      toSetBuyPriceVariant: null,
      variantPriceIsActive: false,
      newRawMaterial: {
        supplier: null,
        additionalSuppliers: null,
        alternateUnits: [],
        unit: null,
        buyPrice: 0.0,
        stock: {
          id: 0,
        },
        variants: [],
      },
      suppliers: [],
      rawMaterialCategories: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      filteredVariants: [],
    };
  },
  computed: {
    defaultVariant() {
      if (
        this.newRawMaterial.variants != null &&
        this.newRawMaterial.variants.length > 0
      )
        return this.newRawMaterial.variants.find((x) => x.isDefault == true);
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("close");
          this.$validator.reset();
          this.initValues();
        }
      },
    },
    activeVariants: function () {
      return this.filteredVariants;
    },
    filteredAdditionalSuppliers() {
      return this.suppliers.filter(s =>
        !this.newRawMaterial.supplier || s.id !== this.newRawMaterial.supplier.id
      );
    }
  },
  methods: {
    saveVariantOptions(variant) {
      console.log(variant);
      console.log(this.newRawMaterial.variants);
      let toSaveVariant = null;
      if(variant.id){
       toSaveVariant = this.newRawMaterial.variants.find(
        (x) => x.id == variant.id
      );
    }else{
      toSaveVariant  = this.newRawMaterial.variants.find(
        (x) => x.name == variant.name
      );
    }
      toSaveVariant.buyPrice = variant.buyPrice;
      toSaveVariant.orderUnit = variant.orderUnit;
      toSaveVariant.buyPriceUnit = variant.buyPriceUnit;
    },
    setVariantBuyPrice(item) {
      this.toSetBuyPriceVariant = item;
      this.variantPriceIsActive = true;
    },
    closeVariantBuyPrice() {
      this.variantPriceIsActive = false;
    },
    setConvertedBuyPrice() {
      if (!this.newRawMaterial.id || this.newRawMaterial.id == 0) return;
      getConvertedBuyPrice(
        this.newRawMaterial.buyPriceUnit.id,
        this.newRawMaterial.id
      )
        .then((res) => {
          if (res && res.status == 200) {
            this.newRawMaterial.buyPrice = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "ALış Fiyatı Çevirilemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası",
          });
        });
    },
    resetBuyPrice() {
      this.newRawMaterial.buyPrice = 0;
      if (
        this.newRawMaterial.variants != null &&
        this.newRawMaterial.variants.length > 0
      ) {
        this.newRawMaterial.variants.forEach((x) => {
          if (x.state != "Deleted") {
            x.buyPrice = 0;
          }
        });
      }
    },
    hasAnyVariants() {
      if (
        this.newRawMaterial.variants != null &&
        this.newRawMaterial.variants.length > 0 &&
        this.newRawMaterial.variants.some(
          (x) => x.state == "Added" || x.state == "Unchanged"
        )
      )
        return true;
      else return false;
    },
    escape() {
      if (this.isSidebarActiveLocal && !this.variantPriceIsActive)
        this.isSidebarActiveLocal = false;
    },
    getCheckStockCode: async function (newStockCode, id) {
      await checkNewStockCode(newStockCode, id).then((res) => {
        this.checkNewStockCode = res.data;
      });
      return this.checkNewStockCode;
    },

    deleteVariants: function (val, index) {
      if (typeof val.id == "undefined") {
        if (val.isDefault) return;
        this.newRawMaterial.variants.splice(index, 1);
      } else {
        val.state = VariantsStateTypes.Deleted;
      }
      this.reloadVariantTable();
    },

    addNewVariants: function () {
      if (!this.newRawMaterial.variants) {
        this.newRawMaterial.variants = [];
      }
      this.newRawMaterial.variants.push({
        stock: {
          id: 0,
        },
        state: VariantsStateTypes.Added,
      });
      this.reloadVariantTable();
    },
    setDefaultVariant: function (indextr, item) {
      this.newRawMaterial.variants = this.newRawMaterial.variants.map(
        (variant, index) => {
          if (index != indextr) {
            variant.isDefault = false;
          }

          return variant;
        }
      );
    },
    getAlternateUnits(id) {
      getFullAlternateList(id)
        .then((res) => {
          if (res && res.status == 200) {
            this.newRawMaterial.alternateUnits = [];
            this.newRawMaterial.alternateUnits = res.data;
            this.newRawMaterial.buyPriceUnit = this.newRawMaterial.alternateUnits.find(
              (x) => x.id == this.newRawMaterial.unit.id
            );
            this.setConvertedBuyPrice();
            if (
              this.newRawMaterial.orderUnit &&
              !this.newRawMaterial.alternateUnits.some(
                (x) => x.id == this.newRawMaterial.orderUnit.id
              )
            )
              this.newRawMaterial.orderUnit = null;

            if (this.newRawMaterial.id && this.newRawMaterial.id != 0) {
              this.units = res.data;
            }
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Alternatif Birimler Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getUnits() {
      getUnitNameList()
        .then((res) => {
          if (res && res.status == 200) {
            this.units = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Birim Listesi Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getRawMaterialCategories() {
      getRawMaterialCategoryNameList()
        .then((res) => {
          if (res && res.status == 200) {
            this.rawMaterialCategories = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hammadde Kategori Listesi Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getSuppliers() {
      getSupplierNameList()
        .then((res) => {
          if (res && res.status == 200) {
            this.suppliers = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Tedarikçi Listesi Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    initValues() {
      this.newRawMaterial = {
        supplier: null,
        additionalSuppliers: [],
        alternateUnits: [],
        unit: null,
        buyPrice: 0.0,
        stock: {
          id: 0,
        },
        variants: [],
      };
      this.reloadVariantTable();
    },
    submitData: async function () {
      let checker;
      console.log(this.newRawMaterial);
      checker = await this.$validator.validateAll("form-1");
      let defaultChecker = this.hasAnyVariants() ? this.defaultVariant : true;
      if (checker && defaultChecker) {
        this.newRawMaterial.kdv = parseInt(this.newRawMaterial.kdv);
        this.newRawMaterial.buyPrice = parseFloat(this.newRawMaterial.buyPrice);
        this.newRawMaterial.minimumOrder = this.newRawMaterial.minimumOrder
          ? parseFloat(this.newRawMaterial.minimumOrder)
          : 0;
        this.newRawMaterial.otherSupplierIds = this.newRawMaterial.additionalSuppliers
          ? this.newRawMaterial.additionalSuppliers.map(supplier => supplier.id)
          : [];
        if (
          this.newRawMaterial.variants &&
          this.newRawMaterial.variants.length > 0
        )
          this.newRawMaterial.variants.forEach((x) => {
            x.buyPrice = parseFloat(x.buyPrice);
          });
        if (this.newRawMaterial.id) {
          updateRawMaterial(this.newRawMaterial)
            .then((res) => {
              if (res && res.status == 200) {
                this.$store.dispatch("rawMaterial/updateRawMaterial", res.data);
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Hammadde Güncelleme İşlemi Başarılı !",
                });
                this.$emit("close");
                this.initValues();
                this.$validator.reset();
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Hammade Güncelleme İşlemi Başarısız ! ",
                });
              }
            })
            .catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası",
              });
            });
        } else {
          this.newRawMaterial.id = 0;
          createNewRawMaterial(this.newRawMaterial)
            .then((res) => {
              if (res && res.status == 200) {
                this.$store
                  .dispatch("rawMaterial/addRawMaterial", res.data)
                  .then(() => {
                    this.$vs.notify({
                      color: "success",
                      title: "Başarılı !",
                      text: "Hammadde Ekleme İşlemi Başarılı !",
                    });
                    this.$emit("close");
                    this.initValues();
                    this.$validator.reset();
                  });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Hammade Ekleme İşlemi Başarısız ! ",
                });
              }
            })
            .catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası ! ",
              });
            });
        }
      }
    },
    mapNewRawMaterial: async function () {
      //map
    },
    reloadVariantTable: function () {
      if (
        this.newRawMaterial.variants != null &&
        this.newRawMaterial.variants.length > 0
      )
        this.filteredVariants = this.newRawMaterial.variants.filter(
          (x) => x.state != VariantsStateTypes.Deleted
        );
      else this.filteredVariants = [];
    },
  },
  components: {
    VuePerfectScrollbar,
    VariantPriceModal,
  },
  watch: {
    isSidebarActive: {
      immediate: true,
      handler(val) {
        if (!val) return;
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
          this.getUnits();
        } else {
          const clonedData = _.cloneDeep(this.data);

          const otherSupplierIds = clonedData.otherSupplierIds || [];

          this.newRawMaterial = {
            ...clonedData,
            additionalSuppliers: [],
            variants: clonedData.variants || []
          };

          this.$nextTick(() => {
            this.newRawMaterial.additionalSuppliers = this.suppliers.filter(s =>
              otherSupplierIds.includes(s.id)
            );
          });

          if (this.newRawMaterial.variants.length > 0) {
            this.newRawMaterial.variants.forEach(
              (item) => (item.state = VariantsStateTypes.Unchanged)
            );
          }

          this.reloadVariantTable();
          if (this.newRawMaterial.unit) {
            this.getAlternateUnits(this.newRawMaterial.unit.id);
          }
        }
      }
    }
  },
  mounted: function () {
    this.getSuppliers();
    this.getRawMaterialCategories();
  },
  created: async function () {
    this.$validator.extend("required_Money", {
      getMessage: "Alış Fiyatı Giriniz.",
      validate: async function (value, field) {
        if (value != "0,00") return true;
        else return false;
      },
    });
    let codeChecker = this.getCheckStockCode;
    let getBackCode;
    this.$validator.extend("checkStockCode", {
      getMessage: "Bu Stok Kodu Kullanımda",
      validate: async function (value, id) {
        await codeChecker(value, id).then((res) => {
          getBackCode = res;
        });
        return !getBackCode;
      },
    });
  },
};
</script>

<style>
.vs__dropdown-menu {
  max-height: 25vh !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  position: absolute !important;
}

.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: red;
  text-transform: lowercase;
  font-variant: small-caps;
}

#newRawMaterialPopup .vs-popup {
  width: 60vw;
}
</style>
